import script from "./ShowMyPresence.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMyPresence.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__